import React from 'react';
import { observer } from 'mobx-react';

import { NotificationModel } from 'shared/models';
import { UiAvatar } from 'shared/uikit';
import { NotificationTypeEnum } from 'shared/enums';

import './styles.scss';
import lodash from 'lodash';

type PropsType = {
    notification: NotificationModel;
};

const icons = {
    default: require('./assets/default.svg').default,
    [NotificationTypeEnum.AnnouncementCreatedNotification.id]: require('./assets/AnnouncementCreated.svg').default,
    [NotificationTypeEnum.ArticleCreatedNotification.id]: require('./assets/ArticleCreated.svg').default,
    [NotificationTypeEnum.BookCreatedNotification.id]: require('./assets/BookCreated.svg').default,
    [NotificationTypeEnum.DocumentNotification.id]: require('./assets/Document.svg').default,
    [NotificationTypeEnum.EducationLessonCreatedNotification.id]: require('./assets/EducationLessonCreated.svg').default,
    [NotificationTypeEnum.EducationLessonRecentNotification.id]: require('./assets/EducationLessonRecent.svg').default,
    [NotificationTypeEnum.GalleryCreatedNotification.id]: require('./assets/GalleryCreated.svg').default,
    [NotificationTypeEnum.NewsCreatedNotification.id]: require('./assets/NewsCreated.svg').default,
    [NotificationTypeEnum.SurveyCreatedNotification.id]: require('./assets/SurveyCreated.svg').default,
    [NotificationTypeEnum.UsersBirthdaysNotification.id]: require('./assets/UsersBirthdays.png'),
    [NotificationTypeEnum.VacancyCreatedNotification.id]: require('./assets/VacancyCreated.svg').default,
};

export const VmNotificationIcon = observer(({ notification }: PropsType) => {
    if (notification.type.is(NotificationTypeEnum.CommentNotification)) {
        return <UiAvatar size={40} label={notification.data.comment.user.previewName} image={notification.data.comment.user.image} />;
    }
    if (notification.type.id.indexOf('TaskTracker') > -1) {
        return <UiAvatar size={40} label={notification.data.task.ownerUser.previewName} image={notification.data.task.ownerUser.image} />;
    }
    return (
        <div
            className={`vm-notification-icon vm-notification-icon--${lodash.kebabCase(notification.type.id)}`}
            style={{ backgroundImage: `url(${icons[notification.type.id] || icons.default})` }}
        />
    );
});
